import { camelToUnderscore } from "./formatting";
import { apiUrls } from "./urls";
import qs from "qs";
import api from "./api";

export const generalAPIDefaultInputOptions = {
  values: [],
  exclude: [],
  count: false,
  page: 0,
  size: 0,
  listValues: false,
  flattenValues: false,
  customSerializer: false,
  keepRelated: false,
  prefetchRelated: [],
  selectRelated: [],
  filter: {},
  annotations: {},
  aggregations: {},
  attach: null,
  orderBy: [],
};

export class GeneralAPI {
  constructor(modelName, inputOptions = generalAPIDefaultInputOptions) {
    if (!modelName) {
      throw new Error("Model name not provided.");
    }

    this.defaults = generalAPIDefaultInputOptions;

    this.options = {};
    this.modelName = modelName;
    this.update(inputOptions);
  }

  update(updatedOptions) {
    for (let [field, val] of Object.entries(updatedOptions)) {
      this.options[field] = val;
    }
  }

  getParams() {
    let searchParams = {};
    Object.entries(this.options).forEach(([field, val]) => {
      if (Array.isArray(val)) {
        val = val.join(",");
      } else if (["filter", "annotations", "aggregations"].includes(field)) {
        val = JSON.stringify(val);
      }
      searchParams[camelToUnderscore(field)] = val;
    });
    return searchParams;
  }

  getPath() {
    const url = `${apiUrls.general()}${this.modelName}/`;
    return url;
  }
  getUrl() {
    return `${this.getPath()}${qs.stringify(this.getParams(), {
      addQueryPrefix: true,
    })}`;
  }
  async send() {
    return await api.get(this.getUrl());
  }
}
